import roles from './roles';

const assignAllowedRoles = {
  SUPER_ADMIN: [
    roles.SUPER_ADMIN,
    roles.ADMIN,
    roles.MANAGER,
    roles.TEAM_LEADER,
    roles.OPERATOR,
    roles.SALE,
    roles.PUBLISHER,
    roles.CUSTOMER,
    roles.CALL_ANALYST,
  ],
  ADMIN: [
    roles.ADMIN,
    roles.MANAGER,
    roles.TEAM_LEADER,
    roles.OPERATOR,
    roles.SALE,
    roles.PUBLISHER,
    roles.CUSTOMER,
    roles.CALL_ANALYST,
  ],
  MANAGER: [roles.MANAGER, roles.TEAM_LEADER, roles.OPERATOR],
  TEAM_LEADER: [roles.TEAM_LEADER, roles.OPERATOR],
  OPERATOR: [roles.TEAM_LEADER, roles.OPERATOR],
  CALL_ANALYST: [roles.CALL_ANALYST],
};

export default assignAllowedRoles;
